import React from "react";
import { Col, Container, Row } from "reactstrap";
import { Link } from "react-router-dom";

// Import Swiper styles
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/pagination";

import { EffectFade, Autoplay } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";

// Import Images
import imgpattern from "../../../assets/images/landing/img-pattern.png";

import defaultDemo from "../../../assets/images/demos/default.png";
import saasDemo from "../../../assets/images/demos/saas.png";
import materialDemo from "../../../assets/images/demos/material.png";
import minimalDemo from "../../../assets/images/demos/minimal.png";
import creativeDemo from "../../../assets/images/demos/creative.png";
import modernDemo from "../../../assets/images/demos/modern.png";
import interactiveDemo from "../../../assets/images/demos/interactive.png";

const Home = () => {
  return (
    <React.Fragment>
      <section className="section pb-0 hero-section" id="hero">
        <div className="bg-overlay bg-overlay-pattern"></div>
        <Container>
          <Row
            className="justify-content-center"
            // style={{ paddingBottom: "100px" }}
          >
            <Col lg={8} sm={10}>
              <div className="text-center mt-lg-5 pt-5">
                <h1 className="display-6 fw-semibold mb-3 lh-base">
                  Enviar Cripto para Várias Carteiras Nunca Foi Tão Fácil!{" "}
                  <span className="text-warning">Fort Multisend </span>
                </h1>
                <p className="lead lh-base" style={{ color: "lightyellow" }}>
                  Você já se viu em uma situação onde precisava enviar
                  criptomoedas para múltiplas carteiras e achou o processo
                  tedioso e demorado? O{" "}
                  <b className="text-warning">FORT MultiSend</b> é a solução
                  perfeita para você! É um recurso exclusivo que permite enviar
                  criptomoedas para várias carteiras com uma única transação,
                  economizando tempo e taxas.
                </p>
              </div>
              <div
                className="mt-4 mt-sm-5 pt-sm-5 mb-sm-n5 demo-carousel d-flex justify-content-center align-items-center"
                style={{
                  position: "relative",
                  paddingBottom: "49.7%",
                  height: 0,
                  overflow: "hidden",
                }}
              >
                <iframe
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                  }}
                  src="https://www.youtube.com/embed/iN7tFaXK270?si=n9zWs-K6yB1Ujsd9"
                  title="Tutorial Fort Multisend"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                ></iframe>
              </div>
            </Col>
          </Row>
        </Container>

        <div className="position-absolute start-0 end-0 bottom-0 hero-shape-svg">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            // xmlns:xlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 1440 120"
          >
            <g mask='url("#SvgjsMask1003")' fill="none">
              <path d="M 0,118 C 288,98.6 1152,40.4 1440,21L1440 140L0 140z"></path>
            </g>
          </svg>
        </div>
      </section>
    </React.Fragment>
  );
};

export default Home;
